import { saveAs } from "file-saver";
import { downloadBillRoute } from "@api-routes";
import { useFetch } from "@common/hook/useFetch";

export const useDownloadBill = (billNumber: number) => {
    const [downloadBillState, { get }] = useFetch();

    const downloadBill = () => {
        get<Blob>(downloadBillRoute(billNumber)).then((blob) => {
            if (blob) {
                saveAs(blob, `${billNumber}_bill.pdf`);
            }
        });
    };

    return { downloadBill, downloadBillState };
};
